import React from 'react';
import classNames from 'classnames';
import UserIcon from '../../icons/User.js';
import WhitepageIcon from '../../icons/Whitepage.js';
import WhitepageMusicIcon from '../../icons/WhitepageMusic.js';
import WhitepageRasterIcon from '../../icons/WhitepageRaster.js';
import WhitepageLinesIcon from '../../icons/WhitepageLines.js';
import MediaIcon from '../../icons/Media.js';

function determineIconProps({ materialType, contentType, paperType, className, }) {
    if (materialType === 'user-material')
        return { svgIcon: React.createElement(UserIcon, { className: className }) };
    if (materialType === 'whitepage') {
        switch (paperType) {
            case 'blank':
                return { svgIcon: React.createElement(WhitepageIcon, { className: className }) };
            case 'media':
                return { svgIcon: React.createElement(WhitepageMusicIcon, { className: className }) };
            case 'raster':
                return { svgIcon: React.createElement(WhitepageRasterIcon, { className: className }) };
            case 'lines':
                return { svgIcon: React.createElement(WhitepageLinesIcon, { className: className }) };
            default:
                return { svgIcon: React.createElement(WhitepageIcon, { className: className }) };
        }
    }
    if (contentType?.iconClassName)
        return { iconClassName: contentType.iconClassName };
    if (contentType?.icon)
        return { image: contentType.icon, name: contentType.name };
    return { svgIcon: React.createElement(MediaIcon, { className: className }) };
}
function MaterialIcon({ materialType, contentType, paperType, className }) {
    const props = determineIconProps({ materialType, contentType, paperType, className });
    if ('svgIcon' in props) {
        return React.createElement(React.Fragment, null, props.svgIcon);
    }
    if ('iconClassName' in props) {
        return React.createElement("i", { className: classNames(className, 'bc-icon', `bc-${props.iconClassName}`), role: 'img' });
    }
    return React.createElement("img", { src: props.image, alt: props.name, className: className });
}

export { MaterialIcon };
